module.exports = function() {
  return new Worker(__webpack_public_path__ + "0f4d30d2d1cf000253f4.worker.js");
};